import { useAppDispatch } from '../../effects/useAppDispatch';
import { useAppSelector } from '../../effects/useAppSelector';
import { loanActions } from '../../actions/loan.actions';
import { SubscriptionFeature } from '../../types/billing/SubscriptionFeature';
import { isRequesting } from '../../utils';
import { ActionBlocker } from '../access/ActionBlocker';
import ExportButton from '../common/ExportButton';

interface LoanMonitorExportButtonProps {
    disabled?: boolean;
}

export function LoanMonitorExportButton({ disabled = false }: LoanMonitorExportButtonProps) {
    const dispatch = useAppDispatch();
    const exportRequestState = useAppSelector(s => s.loan.exportRequestState);
    const isExporting = isRequesting(exportRequestState);

    return (
        <ActionBlocker feature={SubscriptionFeature.LoanExport}>
            <ExportButton
                isExportLoad={isExporting}
                disabled={disabled || isExporting}
                onExport={() => dispatch(loanActions.exportLoans())}
            />
        </ActionBlocker>
    );
}
